<template>
  <div class="todo-logo">
    <h2>ToD<span class="todo-logo-o">o</span>Servy</h2>
    <p v-if="$slots.default">
      <slot />
    </p>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="scss">
  @import '../assets/variables';

  .todo-logo {
    text-align: center;
    color: $color-white;

    h2 {
      font-family: Secular One, serif;
      font-style: normal;
      font-weight: normal;
      font-size: 40px;
      line-height: 58px;

      .todo-logo-o {
        color: $color-secondary;
      }
    }

    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
</style>
